// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./exam-variables.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =========================================================
   ExaminationOS — Global Styles
   Scoped under .exam-app to avoid collisions with AcademicOS
   ========================================================= */

.exam-app *,
.exam-app *::before,
.exam-app *::after {
  box-sizing: border-box;
}

.exam-app {
  font-family: var(--exam-font);
  font-size: 14px;
  line-height: 1.5;
  color: var(--exam-text);
  background: var(--exam-bg);
  min-height: 100vh;
  -webkit-font-smoothing: antialiased;
}

/* ---- Layout Shell ---------------------------------------- */

.exam-shell {
  display: flex;
  height: 100vh;
  overflow: hidden;
}

.exam-main {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  min-width: 0;
  height: 100vh;
  overflow-y: auto;
  overflow-x: hidden;
  margin-left: var(--exam-sidebar-width);
  transition: margin-left var(--exam-transition-slow);
  /* Custom scrollbar */
  scrollbar-width: thin;
  scrollbar-color: var(--exam-border) transparent;
}

.exam-main::-webkit-scrollbar { width: 6px; }
.exam-main::-webkit-scrollbar-track { background: transparent; }
.exam-main::-webkit-scrollbar-thumb { background: var(--exam-border); border-radius: 3px; }
.exam-main::-webkit-scrollbar-thumb:hover { background: var(--exam-text-muted); }

.exam-main.sidebar-collapsed {
  margin-left: var(--exam-sidebar-collapsed);
}

.exam-page {
  flex: 1 1;
  padding: 24px;
  overflow-x: hidden;
}

/* ---- Sidebar --------------------------------------------- */

.exam-sidebar {
  position: fixed;
  top: 0;
  left: 0;
  width: var(--exam-sidebar-width);
  height: 100vh;
  background: linear-gradient(180deg, var(--exam-shell-bg) 0%, var(--exam-shell-mid) 100%);
  border-right: 1px solid var(--exam-shell-border);
  display: flex;
  flex-direction: column;
  z-index: var(--exam-z-sidebar);
  transition: width var(--exam-transition-slow);
  overflow: hidden;
}

.exam-sidebar.collapsed {
  width: var(--exam-sidebar-collapsed);
}

.exam-sidebar-logo {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 0 16px;
  height: var(--exam-header-height);
  border-bottom: 1px solid var(--exam-shell-border);
  flex-shrink: 0;
  text-decoration: none;
  background: rgba(0,0,0,0.15);
}

.exam-sidebar-logo-icon {
  width: 32px;
  height: 32px;
  background: linear-gradient(135deg, #F59E0B 0%, #D97706 100%);
  border-radius: var(--exam-radius-sm);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  box-shadow: 0 2px 8px rgba(245, 158, 11, 0.4);
}

.exam-sidebar-logo-text {
  font-size: 15px;
  font-weight: 700;
  color: var(--exam-shell-text-active);
  white-space: nowrap;
  letter-spacing: -0.02em;
}

.exam-sidebar-logo-text span {
  color: var(--exam-shell-accent);
}

.exam-nav {
  flex: 1 1;
  padding: 12px 8px;
  overflow-y: auto;
  overflow-x: hidden;
}

.exam-nav::-webkit-scrollbar { width: 4px; }
.exam-nav::-webkit-scrollbar-track { background: transparent; }
.exam-nav::-webkit-scrollbar-thumb { background: rgba(255,255,255,0.1); border-radius: 2px; }

.exam-nav-section {
  margin-bottom: 4px;
}

.exam-nav-label {
  font-size: 10.5px;
  font-weight: 600;
  color: rgba(127, 152, 182, 0.7);
  text-transform: uppercase;
  letter-spacing: 0.08em;
  padding: 8px 8px 4px;
  white-space: nowrap;
}

.exam-nav-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 10px;
  border-radius: var(--exam-radius-sm);
  color: var(--exam-shell-text);
  text-decoration: none;
  font-size: 13.5px;
  font-weight: 500;
  transition: background var(--exam-transition), color var(--exam-transition);
  white-space: nowrap;
  cursor: pointer;
  border: none;
  background: none;
  width: 100%;
  text-align: left;
  position: relative;
}

.exam-nav-item:hover {
  background: var(--exam-shell-hover);
  color: var(--exam-shell-text-active);
}

.exam-nav-item.active {
  background: var(--exam-shell-active);
  color: var(--exam-shell-accent);
}

.exam-nav-item.active::before {
  content: '';
  position: absolute;
  left: 0;
  top: 4px;
  bottom: 4px;
  width: 3px;
  background: var(--exam-shell-accent);
  border-radius: 0 2px 2px 0;
}

.exam-nav-item-icon {
  width: 18px;
  height: 18px;
  flex-shrink: 0;
  opacity: 0.6;
}

.exam-nav-item:hover .exam-nav-item-icon { opacity: 0.85; }
.exam-nav-item.active .exam-nav-item-icon { opacity: 1; }

.exam-sidebar-footer {
  padding: 12px 8px;
  border-top: 1px solid var(--exam-shell-border);
  flex-shrink: 0;
  background: rgba(0,0,0,0.12);
}

.exam-user-pill {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px;
  border-radius: var(--exam-radius-sm);
  cursor: pointer;
  transition: background var(--exam-transition);
}

.exam-user-pill:hover { background: var(--exam-shell-hover); }

.exam-avatar {
  width: 32px;
  height: 32px;
  border-radius: var(--exam-radius-full);
  background: linear-gradient(135deg, #F59E0B 0%, #D97706 100%);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  font-weight: 700;
  flex-shrink: 0;
  box-shadow: 0 0 0 2px rgba(245, 158, 11, 0.3);
}

.exam-user-info {
  flex: 1 1;
  min-width: 0;
}

.exam-user-name {
  font-size: 13px;
  font-weight: 600;
  color: var(--exam-shell-text-active);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.exam-user-role {
  font-size: 11px;
  color: var(--exam-shell-text);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* ---- Header ---------------------------------------------- */

.exam-header {
  height: var(--exam-header-height);
  background: var(--exam-surface);
  border-bottom: 1px solid var(--exam-border);
  box-shadow: 0 1px 4px 0 rgb(0 0 0 / 0.06);
  display: flex;
  align-items: center;
  padding: 0 24px;
  gap: 16px;
  position: sticky;
  top: 0;
  z-index: var(--exam-z-header);
}

.exam-header-breadcrumb {
  flex: 1 1;
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  color: var(--exam-text-secondary);
}

.exam-header-breadcrumb a {
  color: var(--exam-text-secondary);
  text-decoration: none;
  font-weight: 500;
}

.exam-header-breadcrumb a:hover { color: var(--exam-primary); }

.exam-header-breadcrumb-sep {
  color: var(--exam-text-muted);
  font-size: 12px;
}

.exam-header-breadcrumb-current {
  color: var(--exam-text);
  font-weight: 600;
}

.exam-header-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

/* ---- Cards ----------------------------------------------- */

.exam-card {
  background: var(--exam-surface);
  border: 1px solid var(--exam-border);
  border-radius: var(--exam-radius-lg);
  padding: 20px 24px;
  box-shadow: var(--exam-shadow-sm);
  transition: box-shadow var(--exam-transition);
}

.exam-card:has(.exam-card-interactive):hover { box-shadow: var(--exam-shadow-md); }

.exam-card-sm {
  padding: 16px 20px;
}

.exam-card-title {
  font-size: 15px;
  font-weight: 600;
  color: var(--exam-text);
  margin: 0 0 4px;
}

.exam-card-subtitle {
  font-size: 12px;
  color: var(--exam-text-muted);
  margin: 0;
}

/* ---- Stat Cards ------------------------------------------ */

.exam-stat-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 16px;
  margin-bottom: 24px;
}

.exam-stat-card {
  background: var(--exam-surface);
  border: 1px solid var(--exam-border);
  border-top: 3px solid var(--exam-primary);
  border-radius: var(--exam-radius-lg);
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  box-shadow: var(--exam-shadow-xs);
  transition: box-shadow var(--exam-transition), transform var(--exam-transition);
}

.exam-stat-card:hover { box-shadow: var(--exam-shadow-md); transform: translateY(-1px); }

.exam-stat-label {
  font-size: 12px;
  font-weight: 500;
  color: var(--exam-text-muted);
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.exam-stat-value {
  font-size: 28px;
  font-weight: 700;
  color: var(--exam-text);
  line-height: 1;
}

.exam-stat-change {
  font-size: 12px;
  color: var(--exam-text-muted);
}

.exam-stat-change.up   { color: var(--exam-success); }
.exam-stat-change.down { color: var(--exam-error);   }

.exam-stat-icon {
  width: 36px;
  height: 36px;
  border-radius: var(--exam-radius-sm);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 4px;
}

/* ---- Pipeline Status ------------------------------------- */

.exam-pipeline {
  display: flex;
  gap: 0;
  background: var(--exam-surface);
  border: 1px solid var(--exam-border);
  border-radius: var(--exam-radius-lg);
  overflow: hidden;
}

.exam-pipeline-step {
  flex: 1 1;
  padding: 12px 16px;
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  border-right: 1px solid var(--exam-border);
  transition: background var(--exam-transition);
  text-decoration: none;
  color: inherit;
}

.exam-pipeline-step:last-child { border-right: none; }
.exam-pipeline-step:hover { background: var(--exam-surface-hover); }
.exam-pipeline-step.active { background: var(--exam-primary-light); }

.exam-pipeline-dot {
  width: 10px;
  height: 10px;
  border-radius: var(--exam-radius-full);
  background: var(--exam-border-strong);
  flex-shrink: 0;
}

.exam-pipeline-dot.ready    { background: var(--exam-success); }
.exam-pipeline-dot.pending  { background: var(--exam-border-strong); }
.exam-pipeline-dot.active   { background: var(--exam-primary); }
.exam-pipeline-dot.error    { background: var(--exam-error); }
.exam-pipeline-dot.generating { background: var(--exam-warning); }

.exam-pipeline-step-name {
  font-size: 12px;
  font-weight: 500;
  color: var(--exam-text-secondary);
  white-space: nowrap;
}

.exam-pipeline-step.active .exam-pipeline-step-name { color: var(--exam-primary); }

/* ---- Buttons --------------------------------------------- */

.exam-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  font-family: var(--exam-font);
  font-size: 13.5px;
  font-weight: 500;
  line-height: 1;
  border: none;
  border-radius: var(--exam-radius-sm);
  cursor: pointer;
  transition: background var(--exam-transition), box-shadow var(--exam-transition), opacity var(--exam-transition);
  white-space: nowrap;
  text-decoration: none;
}

.exam-btn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.exam-btn-sm  { padding: 6px 12px; font-size: 12.5px; }
.exam-btn-md  { padding: 8px 16px; }
.exam-btn-lg  { padding: 10px 20px; font-size: 14.5px; }

.exam-btn-primary {
  background: var(--exam-primary);
  color: var(--exam-text-inverse);
}
.exam-btn-primary:hover:not(:disabled) { background: var(--exam-primary-hover); }

.exam-btn-secondary {
  background: var(--exam-secondary);
  color: var(--exam-text-inverse);
}
.exam-btn-secondary:hover:not(:disabled) { background: var(--exam-secondary-hover); }

.exam-btn-outline {
  background: transparent;
  color: var(--exam-primary);
  border: 1px solid var(--exam-primary-muted);
}
.exam-btn-outline:hover:not(:disabled) { background: var(--exam-primary-light); }

.exam-btn-ghost {
  background: transparent;
  color: var(--exam-text-secondary);
}
.exam-btn-ghost:hover:not(:disabled) { background: var(--exam-surface-hover); color: var(--exam-text); }

/* Ghost variant inside the dark sidebar */
.exam-sidebar .exam-btn-ghost {
  color: var(--exam-shell-text);
}
.exam-sidebar .exam-btn-ghost:hover:not(:disabled) {
  background: var(--exam-shell-hover);
  color: var(--exam-shell-text-active);
}

.exam-btn-danger {
  background: var(--exam-error);
  color: var(--exam-text-inverse);
}

/* ---- Badges ---------------------------------------------- */

.exam-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 11px;
  font-weight: 600;
  padding: 2px 8px;
  border-radius: var(--exam-radius-full);
  letter-spacing: 0.02em;
  white-space: nowrap;
}

.exam-badge-default  { background: var(--exam-surface-hover); color: var(--exam-text-secondary); }
.exam-badge-primary  { background: var(--exam-primary-light); color: var(--exam-primary); }
.exam-badge-success  { background: var(--exam-success-light); color: var(--exam-success); }
.exam-badge-warning  { background: var(--exam-warning-light); color: var(--exam-warning); }
.exam-badge-error    { background: var(--exam-error-light);   color: var(--exam-error); }
.exam-badge-info     { background: var(--exam-info-light);    color: var(--exam-info); }

/* ---- Form Elements --------------------------------------- */

.exam-field {
  display: flex;
  flex-direction: column;
  gap: 5px;
  margin-bottom: 16px;
}

.exam-label {
  font-size: 12.5px;
  font-weight: 500;
  color: var(--exam-text-secondary);
}

.exam-label.required::after {
  content: ' *';
  color: var(--exam-error);
}

.exam-input,
.exam-select,
.exam-textarea {
  font-family: var(--exam-font);
  font-size: 13.5px;
  color: var(--exam-text);
  background: var(--exam-surface);
  border: 1px solid var(--exam-border-strong);
  border-radius: var(--exam-radius-sm);
  padding: 8px 12px;
  width: 100%;
  transition: border-color var(--exam-transition), box-shadow var(--exam-transition);
  outline: none;
}

.exam-input:focus,
.exam-select:focus,
.exam-textarea:focus {
  border-color: var(--exam-primary);
  box-shadow: 0 0 0 3px var(--exam-primary-light);
}

.exam-input::placeholder { color: var(--exam-text-muted); }

.exam-textarea { resize: vertical; min-height: 80px; }

/* ---- Step Progress --------------------------------------- */

.exam-steps {
  display: flex;
  align-items: center;
  margin-bottom: 32px;
}

.exam-step {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  position: relative;
  flex: 1 1;
}

.exam-step:not(:last-child)::after {
  content: '';
  position: absolute;
  top: 14px;
  left: calc(50% + 14px);
  right: calc(-50% + 14px);
  height: 2px;
  background: var(--exam-border);
}

.exam-step.completed::after { background: var(--exam-primary); }

.exam-step-circle {
  width: 28px;
  height: 28px;
  border-radius: var(--exam-radius-full);
  border: 2px solid var(--exam-border-strong);
  background: var(--exam-surface);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 600;
  color: var(--exam-text-muted);
  z-index: 1;
  transition: all var(--exam-transition);
}

.exam-step.completed .exam-step-circle {
  background: var(--exam-primary);
  border-color: var(--exam-primary);
  color: white;
}

.exam-step.current .exam-step-circle {
  border-color: var(--exam-primary);
  color: var(--exam-primary);
  box-shadow: 0 0 0 4px var(--exam-primary-light);
}

.exam-step-label {
  font-size: 11px;
  font-weight: 500;
  color: var(--exam-text-muted);
  text-align: center;
  white-space: nowrap;
}

.exam-step.current .exam-step-label,
.exam-step.completed .exam-step-label {
  color: var(--exam-text-secondary);
}

/* ---- Modal ----------------------------------------------- */

.exam-modal-backdrop {
  position: fixed;
  inset: 0;
  background: rgb(0 0 0 / 0.45);
  z-index: var(--exam-z-modal);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
}

.exam-modal {
  background: var(--exam-surface);
  border-radius: var(--exam-radius-xl);
  box-shadow: var(--exam-shadow-lg);
  width: 100%;
  max-width: 560px;
  max-height: calc(100vh - 48px);
  overflow-y: auto;
  display: flex;
  flex-direction: column;
}

.exam-modal-lg { max-width: 760px; }
.exam-modal-xl { max-width: 960px; }

.exam-modal-header {
  padding: 20px 24px 0;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
}

.exam-modal-title {
  font-size: 17px;
  font-weight: 700;
  color: var(--exam-text);
  margin: 0;
}

.exam-modal-close {
  width: 28px;
  height: 28px;
  border: none;
  background: transparent;
  border-radius: var(--exam-radius-sm);
  cursor: pointer;
  color: var(--exam-text-muted);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background var(--exam-transition);
  flex-shrink: 0;
}

.exam-modal-close:hover { background: var(--exam-surface-hover); color: var(--exam-text); }

.exam-modal-body {
  padding: 16px 24px;
  flex: 1 1;
}

.exam-modal-footer {
  padding: 0 24px 20px;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

/* ---- Table ----------------------------------------------- */

.exam-table-wrap {
  background: var(--exam-surface);
  border: 1px solid var(--exam-border);
  border-radius: var(--exam-radius-lg);
  overflow: hidden;
}

.exam-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13.5px;
}

.exam-table th {
  text-align: left;
  padding: 10px 16px;
  font-size: 11.5px;
  font-weight: 600;
  color: var(--exam-text-muted);
  text-transform: uppercase;
  letter-spacing: 0.04em;
  border-bottom: 1px solid var(--exam-border);
  background: var(--exam-bg);
}

.exam-table td {
  padding: 12px 16px;
  color: var(--exam-text);
  border-bottom: 1px solid var(--exam-border);
  vertical-align: middle;
}

.exam-table tbody tr:last-child td { border-bottom: none; }

.exam-table tbody tr:hover td { background: var(--exam-surface-hover); }

/* ---- Empty State ----------------------------------------- */

.exam-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 60px 24px;
  gap: 12px;
}

.exam-empty-icon {
  width: 56px;
  height: 56px;
  border-radius: var(--exam-radius-lg);
  background: var(--exam-primary-light);
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--exam-primary);
  margin-bottom: 4px;
}

.exam-empty-title {
  font-size: 16px;
  font-weight: 600;
  color: var(--exam-text);
  margin: 0;
}

.exam-empty-body {
  font-size: 13.5px;
  color: var(--exam-text-muted);
  margin: 0;
  max-width: 320px;
}

/* ---- Utilities ------------------------------------------- */

.exam-divider {
  height: 1px;
  background: var(--exam-border);
  margin: 16px 0;
}

.exam-grid-2 { display: grid; grid-template-columns: 1fr 1fr; gap: 16px; }
.exam-grid-3 { display: grid; grid-template-columns: repeat(3, 1fr); gap: 16px; }
.exam-grid-4 { display: grid; grid-template-columns: repeat(4, 1fr); gap: 16px; }

@media (max-width: 768px) {
  .exam-grid-2,
  .exam-grid-3,
  .exam-grid-4 { grid-template-columns: 1fr; }

  .exam-main { margin-left: 0; }
  .exam-sidebar { transform: translateX(-100%); }
  .exam-sidebar.mobile-open { transform: translateX(0); }
}

/* ---- Loading spinner ------------------------------------- */

.exam-spinner {
  width: 20px;
  height: 20px;
  border: 2px solid var(--exam-border);
  border-top-color: var(--exam-primary);
  border-radius: 50%;
  animation: exam-spin 0.7s linear infinite;
  display: inline-block;
}

@keyframes exam-spin {
  to { transform: rotate(360deg); }
}

/* ---- Page headers ---------------------------------------- */

.exam-page-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 24px;
  gap: 16px;
  flex-wrap: wrap;
}

.exam-page-title {
  font-size: 20px;
  font-weight: 700;
  color: var(--exam-text);
  margin: 0;
  letter-spacing: -0.02em;
}

.exam-page-subtitle {
  font-size: 13px;
  color: var(--exam-text-muted);
  margin: 2px 0 0;
}

/* ---- Search & Filter bar --------------------------------- */

.exam-filter-bar {
  display: flex;
  gap: 10px;
  align-items: center;
  flex-wrap: wrap;
  margin-bottom: 16px;
}

.exam-search-input {
  flex: 1 1;
  min-width: 200px;
  max-width: 360px;
  position: relative;
}

.exam-search-input input {
  padding-left: 34px;
}

.exam-search-icon {
  position: absolute;
  left: 10px;
  top: 50%;
  transform: translateY(-50%);
  color: var(--exam-text-muted);
  pointer-events: none;
}
`, "",{"version":3,"sources":["webpack://./src/examination/styles/examination.css"],"names":[],"mappings":"AAEA;;;8DAG8D;;AAE9D;;;EAGE,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,0BAA0B;EAC1B,iBAAiB;EACjB,mCAAmC;AACrC;;AAEA,+DAA+D;;AAE/D;EACE,aAAa;EACb,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,sCAAsC;EACtC,mDAAmD;EACnD,qBAAqB;EACrB,qBAAqB;EACrB,+CAA+C;AACjD;;AAEA,gCAAgC,UAAU,EAAE;AAC5C,sCAAsC,uBAAuB,EAAE;AAC/D,sCAAsC,8BAA8B,EAAE,kBAAkB,EAAE;AAC1F,4CAA4C,kCAAkC,EAAE;;AAEhF;EACE,0CAA0C;AAC5C;;AAEA;EACE,SAAO;EACP,aAAa;EACb,kBAAkB;AACpB;;AAEA,+DAA+D;;AAE/D;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,gCAAgC;EAChC,aAAa;EACb,wFAAwF;EACxF,gDAAgD;EAChD,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,6CAA6C;EAC7C,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,iCAAiC;EACjC,iDAAiD;EACjD,cAAc;EACd,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,6DAA6D;EAC7D,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,6CAA6C;AAC/C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oCAAoC;EACpC,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,SAAO;EACP,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,+BAA+B,UAAU,EAAE;AAC3C,qCAAqC,uBAAuB,EAAE;AAC9D,qCAAqC,iCAAiC,EAAE,kBAAkB,EAAE;;AAE5F;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,+BAA+B;EAC/B,yBAAyB;EACzB,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,oCAAoC;EACpC,6BAA6B;EAC7B,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,2EAA2E;EAC3E,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;EACnC,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;EACpC,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,WAAW;EACX,UAAU;EACV,oCAAoC;EACpC,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,YAAY;AACd;;AAEA,2CAA2C,aAAa,EAAE;AAC1D,4CAA4C,UAAU,EAAE;;AAExD;EACE,iBAAiB;EACjB,8CAA8C;EAC9C,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;EACZ,oCAAoC;EACpC,eAAe;EACf,6CAA6C;AAC/C;;AAEA,wBAAwB,mCAAmC,EAAE;;AAE7D;EACE,WAAW;EACX,YAAY;EACZ,sCAAsC;EACtC,6DAA6D;EAC7D,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,6CAA6C;AAC/C;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oCAAoC;EACpC,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,6BAA6B;EAC7B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,+DAA+D;;AAE/D;EACE,iCAAiC;EACjC,+BAA+B;EAC/B,2CAA2C;EAC3C,yCAAyC;EACzC,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,gBAAgB;EAChB,MAAM;EACN,6BAA6B;AAC/B;;AAEA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;EACjC,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA,kCAAkC,0BAA0B,EAAE;;AAE9D;EACE,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA,+DAA+D;;AAE/D;EACE,+BAA+B;EAC/B,oCAAoC;EACpC,oCAAoC;EACpC,kBAAkB;EAClB,iCAAiC;EACjC,6CAA6C;AAC/C;;AAEA,+CAA+C,iCAAiC,EAAE;;AAElF;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,6BAA6B;EAC7B,SAAS;AACX;;AAEA,+DAA+D;;AAE/D;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,oCAAoC;EACpC,yCAAyC;EACzC,oCAAoC;EACpC,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iCAAiC;EACjC,+EAA+E;AACjF;;AAEA,wBAAwB,iCAAiC,EAAE,2BAA2B,EAAE;;AAExF;EACE,eAAe;EACf,gBAAgB;EAChB,6BAA6B;EAC7B,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,6BAA6B;AAC/B;;AAEA,yBAAyB,0BAA0B,EAAE;AACrD,yBAAyB,wBAAwB,IAAI;;AAErD;EACE,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA,+DAA+D;;AAE/D;EACE,aAAa;EACb,MAAM;EACN,+BAA+B;EAC/B,oCAAoC;EACpC,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,0CAA0C;EAC1C,6CAA6C;EAC7C,qBAAqB;EACrB,cAAc;AAChB;;AAEA,iCAAiC,kBAAkB,EAAE;AACrD,4BAA4B,qCAAqC,EAAE;AACnE,6BAA6B,qCAAqC,EAAE;;AAEpE;EACE,WAAW;EACX,YAAY;EACZ,sCAAsC;EACtC,qCAAqC;EACrC,cAAc;AAChB;;AAEA,8BAA8B,+BAA+B,EAAE;AAC/D,8BAA8B,qCAAqC,EAAE;AACrE,8BAA8B,+BAA+B,EAAE;AAC/D,8BAA8B,6BAA6B,EAAE;AAC7D,gCAAgC,+BAA+B,EAAE;;AAEjE;EACE,eAAe;EACf,gBAAgB;EAChB,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA,sDAAsD,0BAA0B,EAAE;;AAElF,+DAA+D;;AAE/D;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,6BAA6B;EAC7B,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,YAAY;EACZ,oCAAoC;EACpC,eAAe;EACf,gHAAgH;EAChH,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA,gBAAgB,iBAAiB,EAAE,iBAAiB,EAAE;AACtD,gBAAgB,iBAAiB,EAAE;AACnC,gBAAgB,kBAAkB,EAAE,iBAAiB,EAAE;;AAEvD;EACE,+BAA+B;EAC/B,+BAA+B;AACjC;AACA,yCAAyC,qCAAqC,EAAE;;AAEhF;EACE,iCAAiC;EACjC,+BAA+B;AACjC;AACA,2CAA2C,uCAAuC,EAAE;;AAEpF;EACE,uBAAuB;EACvB,0BAA0B;EAC1B,2CAA2C;AAC7C;AACA,yCAAyC,qCAAqC,EAAE;;AAEhF;EACE,uBAAuB;EACvB,iCAAiC;AACnC;AACA,uCAAuC,qCAAqC,EAAE,uBAAuB,EAAE;;AAEvG,0CAA0C;AAC1C;EACE,6BAA6B;AAC/B;AACA;EACE,mCAAmC;EACnC,oCAAoC;AACtC;;AAEA;EACE,6BAA6B;EAC7B,+BAA+B;AACjC;;AAEA,+DAA+D;;AAE/D;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,sCAAsC;EACtC,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA,uBAAuB,qCAAqC,EAAE,iCAAiC,EAAE;AACjG,uBAAuB,qCAAqC,EAAE,0BAA0B,EAAE;AAC1F,uBAAuB,qCAAqC,EAAE,0BAA0B,EAAE;AAC1F,uBAAuB,qCAAqC,EAAE,0BAA0B,EAAE;AAC1F,uBAAuB,mCAAmC,IAAI,wBAAwB,EAAE;AACxF,uBAAuB,kCAAkC,KAAK,uBAAuB,EAAE;;AAEvF,+DAA+D;;AAE/D;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,wBAAwB;AAC1B;;AAEA;;;EAGE,6BAA6B;EAC7B,iBAAiB;EACjB,uBAAuB;EACvB,+BAA+B;EAC/B,2CAA2C;EAC3C,oCAAoC;EACpC,iBAAiB;EACjB,WAAW;EACX,kFAAkF;EAClF,aAAa;AACf;;AAEA;;;EAGE,iCAAiC;EACjC,+CAA+C;AACjD;;AAEA,2BAA2B,6BAA6B,EAAE;;AAE1D,iBAAiB,gBAAgB,EAAE,gBAAgB,EAAE;;AAErD,+DAA+D;;AAE/D;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,SAAO;AACT;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,sBAAsB;EACtB,wBAAwB;EACxB,WAAW;EACX,8BAA8B;AAChC;;AAEA,8BAA8B,+BAA+B,EAAE;;AAE/D;EACE,WAAW;EACX,YAAY;EACZ,sCAAsC;EACtC,2CAA2C;EAC3C,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,6BAA6B;EAC7B,UAAU;EACV,sCAAsC;AACxC;;AAEA;EACE,+BAA+B;EAC/B,iCAAiC;EACjC,YAAY;AACd;;AAEA;EACE,iCAAiC;EACjC,0BAA0B;EAC1B,+CAA+C;AACjD;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,6BAA6B;EAC7B,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;;EAEE,iCAAiC;AACnC;;AAEA,+DAA+D;;AAE/D;EACE,eAAe;EACf,QAAQ;EACR,6BAA6B;EAC7B,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,+BAA+B;EAC/B,oCAAoC;EACpC,iCAAiC;EACjC,WAAW;EACX,gBAAgB;EAChB,8BAA8B;EAC9B,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA,iBAAiB,gBAAgB,EAAE;AACnC,iBAAiB,gBAAgB,EAAE;;AAEnC;EACE,oBAAoB;EACpB,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,oCAAoC;EACpC,eAAe;EACf,6BAA6B;EAC7B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6CAA6C;EAC7C,cAAc;AAChB;;AAEA,0BAA0B,qCAAqC,EAAE,uBAAuB,EAAE;;AAE1F;EACE,kBAAkB;EAClB,SAAO;AACT;;AAEA;EACE,oBAAoB;EACpB,aAAa;EACb,yBAAyB;EACzB,SAAS;AACX;;AAEA,+DAA+D;;AAE/D;EACE,+BAA+B;EAC/B,oCAAoC;EACpC,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,6BAA6B;EAC7B,yBAAyB;EACzB,sBAAsB;EACtB,2CAA2C;EAC3C,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,2CAA2C;EAC3C,sBAAsB;AACxB;;AAEA,qCAAqC,mBAAmB,EAAE;;AAE1D,gCAAgC,qCAAqC,EAAE;;AAEvE,+DAA+D;;AAE/D;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,qCAAqC;EACrC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,6BAA6B;EAC7B,SAAS;EACT,gBAAgB;AAClB;;AAEA,+DAA+D;;AAE/D;EACE,WAAW;EACX,8BAA8B;EAC9B,cAAc;AAChB;;AAEA,eAAe,aAAa,EAAE,8BAA8B,EAAE,SAAS,EAAE;AACzE,eAAe,aAAa,EAAE,qCAAqC,EAAE,SAAS,EAAE;AAChF,eAAe,aAAa,EAAE,qCAAqC,EAAE,SAAS,EAAE;;AAEhF;EACE;;iBAEe,0BAA0B,EAAE;;EAE3C,aAAa,cAAc,EAAE;EAC7B,gBAAgB,4BAA4B,EAAE;EAC9C,4BAA4B,wBAAwB,EAAE;AACxD;;AAEA,+DAA+D;;AAE/D;EACE,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,qCAAqC;EACrC,kBAAkB;EAClB,yCAAyC;EACzC,qBAAqB;AACvB;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA,+DAA+D;;AAE/D;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,6BAA6B;EAC7B,eAAe;AACjB;;AAEA,+DAA+D;;AAE/D;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,6BAA6B;EAC7B,oBAAoB;AACtB","sourcesContent":["@import './exam-variables.css';\n\n/* =========================================================\n   ExaminationOS — Global Styles\n   Scoped under .exam-app to avoid collisions with AcademicOS\n   ========================================================= */\n\n.exam-app *,\n.exam-app *::before,\n.exam-app *::after {\n  box-sizing: border-box;\n}\n\n.exam-app {\n  font-family: var(--exam-font);\n  font-size: 14px;\n  line-height: 1.5;\n  color: var(--exam-text);\n  background: var(--exam-bg);\n  min-height: 100vh;\n  -webkit-font-smoothing: antialiased;\n}\n\n/* ---- Layout Shell ---------------------------------------- */\n\n.exam-shell {\n  display: flex;\n  height: 100vh;\n  overflow: hidden;\n}\n\n.exam-main {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n  height: 100vh;\n  overflow-y: auto;\n  overflow-x: hidden;\n  margin-left: var(--exam-sidebar-width);\n  transition: margin-left var(--exam-transition-slow);\n  /* Custom scrollbar */\n  scrollbar-width: thin;\n  scrollbar-color: var(--exam-border) transparent;\n}\n\n.exam-main::-webkit-scrollbar { width: 6px; }\n.exam-main::-webkit-scrollbar-track { background: transparent; }\n.exam-main::-webkit-scrollbar-thumb { background: var(--exam-border); border-radius: 3px; }\n.exam-main::-webkit-scrollbar-thumb:hover { background: var(--exam-text-muted); }\n\n.exam-main.sidebar-collapsed {\n  margin-left: var(--exam-sidebar-collapsed);\n}\n\n.exam-page {\n  flex: 1;\n  padding: 24px;\n  overflow-x: hidden;\n}\n\n/* ---- Sidebar --------------------------------------------- */\n\n.exam-sidebar {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: var(--exam-sidebar-width);\n  height: 100vh;\n  background: linear-gradient(180deg, var(--exam-shell-bg) 0%, var(--exam-shell-mid) 100%);\n  border-right: 1px solid var(--exam-shell-border);\n  display: flex;\n  flex-direction: column;\n  z-index: var(--exam-z-sidebar);\n  transition: width var(--exam-transition-slow);\n  overflow: hidden;\n}\n\n.exam-sidebar.collapsed {\n  width: var(--exam-sidebar-collapsed);\n}\n\n.exam-sidebar-logo {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 0 16px;\n  height: var(--exam-header-height);\n  border-bottom: 1px solid var(--exam-shell-border);\n  flex-shrink: 0;\n  text-decoration: none;\n  background: rgba(0,0,0,0.15);\n}\n\n.exam-sidebar-logo-icon {\n  width: 32px;\n  height: 32px;\n  background: linear-gradient(135deg, #F59E0B 0%, #D97706 100%);\n  border-radius: var(--exam-radius-sm);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  box-shadow: 0 2px 8px rgba(245, 158, 11, 0.4);\n}\n\n.exam-sidebar-logo-text {\n  font-size: 15px;\n  font-weight: 700;\n  color: var(--exam-shell-text-active);\n  white-space: nowrap;\n  letter-spacing: -0.02em;\n}\n\n.exam-sidebar-logo-text span {\n  color: var(--exam-shell-accent);\n}\n\n.exam-nav {\n  flex: 1;\n  padding: 12px 8px;\n  overflow-y: auto;\n  overflow-x: hidden;\n}\n\n.exam-nav::-webkit-scrollbar { width: 4px; }\n.exam-nav::-webkit-scrollbar-track { background: transparent; }\n.exam-nav::-webkit-scrollbar-thumb { background: rgba(255,255,255,0.1); border-radius: 2px; }\n\n.exam-nav-section {\n  margin-bottom: 4px;\n}\n\n.exam-nav-label {\n  font-size: 10.5px;\n  font-weight: 600;\n  color: rgba(127, 152, 182, 0.7);\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  padding: 8px 8px 4px;\n  white-space: nowrap;\n}\n\n.exam-nav-item {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 8px 10px;\n  border-radius: var(--exam-radius-sm);\n  color: var(--exam-shell-text);\n  text-decoration: none;\n  font-size: 13.5px;\n  font-weight: 500;\n  transition: background var(--exam-transition), color var(--exam-transition);\n  white-space: nowrap;\n  cursor: pointer;\n  border: none;\n  background: none;\n  width: 100%;\n  text-align: left;\n  position: relative;\n}\n\n.exam-nav-item:hover {\n  background: var(--exam-shell-hover);\n  color: var(--exam-shell-text-active);\n}\n\n.exam-nav-item.active {\n  background: var(--exam-shell-active);\n  color: var(--exam-shell-accent);\n}\n\n.exam-nav-item.active::before {\n  content: '';\n  position: absolute;\n  left: 0;\n  top: 4px;\n  bottom: 4px;\n  width: 3px;\n  background: var(--exam-shell-accent);\n  border-radius: 0 2px 2px 0;\n}\n\n.exam-nav-item-icon {\n  width: 18px;\n  height: 18px;\n  flex-shrink: 0;\n  opacity: 0.6;\n}\n\n.exam-nav-item:hover .exam-nav-item-icon { opacity: 0.85; }\n.exam-nav-item.active .exam-nav-item-icon { opacity: 1; }\n\n.exam-sidebar-footer {\n  padding: 12px 8px;\n  border-top: 1px solid var(--exam-shell-border);\n  flex-shrink: 0;\n  background: rgba(0,0,0,0.12);\n}\n\n.exam-user-pill {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 8px;\n  border-radius: var(--exam-radius-sm);\n  cursor: pointer;\n  transition: background var(--exam-transition);\n}\n\n.exam-user-pill:hover { background: var(--exam-shell-hover); }\n\n.exam-avatar {\n  width: 32px;\n  height: 32px;\n  border-radius: var(--exam-radius-full);\n  background: linear-gradient(135deg, #F59E0B 0%, #D97706 100%);\n  color: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 13px;\n  font-weight: 700;\n  flex-shrink: 0;\n  box-shadow: 0 0 0 2px rgba(245, 158, 11, 0.3);\n}\n\n.exam-user-info {\n  flex: 1;\n  min-width: 0;\n}\n\n.exam-user-name {\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--exam-shell-text-active);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.exam-user-role {\n  font-size: 11px;\n  color: var(--exam-shell-text);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n/* ---- Header ---------------------------------------------- */\n\n.exam-header {\n  height: var(--exam-header-height);\n  background: var(--exam-surface);\n  border-bottom: 1px solid var(--exam-border);\n  box-shadow: 0 1px 4px 0 rgb(0 0 0 / 0.06);\n  display: flex;\n  align-items: center;\n  padding: 0 24px;\n  gap: 16px;\n  position: sticky;\n  top: 0;\n  z-index: var(--exam-z-header);\n}\n\n.exam-header-breadcrumb {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 13px;\n  color: var(--exam-text-secondary);\n}\n\n.exam-header-breadcrumb a {\n  color: var(--exam-text-secondary);\n  text-decoration: none;\n  font-weight: 500;\n}\n\n.exam-header-breadcrumb a:hover { color: var(--exam-primary); }\n\n.exam-header-breadcrumb-sep {\n  color: var(--exam-text-muted);\n  font-size: 12px;\n}\n\n.exam-header-breadcrumb-current {\n  color: var(--exam-text);\n  font-weight: 600;\n}\n\n.exam-header-actions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n/* ---- Cards ----------------------------------------------- */\n\n.exam-card {\n  background: var(--exam-surface);\n  border: 1px solid var(--exam-border);\n  border-radius: var(--exam-radius-lg);\n  padding: 20px 24px;\n  box-shadow: var(--exam-shadow-sm);\n  transition: box-shadow var(--exam-transition);\n}\n\n.exam-card:has(.exam-card-interactive):hover { box-shadow: var(--exam-shadow-md); }\n\n.exam-card-sm {\n  padding: 16px 20px;\n}\n\n.exam-card-title {\n  font-size: 15px;\n  font-weight: 600;\n  color: var(--exam-text);\n  margin: 0 0 4px;\n}\n\n.exam-card-subtitle {\n  font-size: 12px;\n  color: var(--exam-text-muted);\n  margin: 0;\n}\n\n/* ---- Stat Cards ------------------------------------------ */\n\n.exam-stat-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));\n  gap: 16px;\n  margin-bottom: 24px;\n}\n\n.exam-stat-card {\n  background: var(--exam-surface);\n  border: 1px solid var(--exam-border);\n  border-top: 3px solid var(--exam-primary);\n  border-radius: var(--exam-radius-lg);\n  padding: 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  box-shadow: var(--exam-shadow-xs);\n  transition: box-shadow var(--exam-transition), transform var(--exam-transition);\n}\n\n.exam-stat-card:hover { box-shadow: var(--exam-shadow-md); transform: translateY(-1px); }\n\n.exam-stat-label {\n  font-size: 12px;\n  font-weight: 500;\n  color: var(--exam-text-muted);\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n}\n\n.exam-stat-value {\n  font-size: 28px;\n  font-weight: 700;\n  color: var(--exam-text);\n  line-height: 1;\n}\n\n.exam-stat-change {\n  font-size: 12px;\n  color: var(--exam-text-muted);\n}\n\n.exam-stat-change.up   { color: var(--exam-success); }\n.exam-stat-change.down { color: var(--exam-error);   }\n\n.exam-stat-icon {\n  width: 36px;\n  height: 36px;\n  border-radius: var(--exam-radius-sm);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 4px;\n}\n\n/* ---- Pipeline Status ------------------------------------- */\n\n.exam-pipeline {\n  display: flex;\n  gap: 0;\n  background: var(--exam-surface);\n  border: 1px solid var(--exam-border);\n  border-radius: var(--exam-radius-lg);\n  overflow: hidden;\n}\n\n.exam-pipeline-step {\n  flex: 1;\n  padding: 12px 16px;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  cursor: pointer;\n  border-right: 1px solid var(--exam-border);\n  transition: background var(--exam-transition);\n  text-decoration: none;\n  color: inherit;\n}\n\n.exam-pipeline-step:last-child { border-right: none; }\n.exam-pipeline-step:hover { background: var(--exam-surface-hover); }\n.exam-pipeline-step.active { background: var(--exam-primary-light); }\n\n.exam-pipeline-dot {\n  width: 10px;\n  height: 10px;\n  border-radius: var(--exam-radius-full);\n  background: var(--exam-border-strong);\n  flex-shrink: 0;\n}\n\n.exam-pipeline-dot.ready    { background: var(--exam-success); }\n.exam-pipeline-dot.pending  { background: var(--exam-border-strong); }\n.exam-pipeline-dot.active   { background: var(--exam-primary); }\n.exam-pipeline-dot.error    { background: var(--exam-error); }\n.exam-pipeline-dot.generating { background: var(--exam-warning); }\n\n.exam-pipeline-step-name {\n  font-size: 12px;\n  font-weight: 500;\n  color: var(--exam-text-secondary);\n  white-space: nowrap;\n}\n\n.exam-pipeline-step.active .exam-pipeline-step-name { color: var(--exam-primary); }\n\n/* ---- Buttons --------------------------------------------- */\n\n.exam-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  font-family: var(--exam-font);\n  font-size: 13.5px;\n  font-weight: 500;\n  line-height: 1;\n  border: none;\n  border-radius: var(--exam-radius-sm);\n  cursor: pointer;\n  transition: background var(--exam-transition), box-shadow var(--exam-transition), opacity var(--exam-transition);\n  white-space: nowrap;\n  text-decoration: none;\n}\n\n.exam-btn:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n.exam-btn-sm  { padding: 6px 12px; font-size: 12.5px; }\n.exam-btn-md  { padding: 8px 16px; }\n.exam-btn-lg  { padding: 10px 20px; font-size: 14.5px; }\n\n.exam-btn-primary {\n  background: var(--exam-primary);\n  color: var(--exam-text-inverse);\n}\n.exam-btn-primary:hover:not(:disabled) { background: var(--exam-primary-hover); }\n\n.exam-btn-secondary {\n  background: var(--exam-secondary);\n  color: var(--exam-text-inverse);\n}\n.exam-btn-secondary:hover:not(:disabled) { background: var(--exam-secondary-hover); }\n\n.exam-btn-outline {\n  background: transparent;\n  color: var(--exam-primary);\n  border: 1px solid var(--exam-primary-muted);\n}\n.exam-btn-outline:hover:not(:disabled) { background: var(--exam-primary-light); }\n\n.exam-btn-ghost {\n  background: transparent;\n  color: var(--exam-text-secondary);\n}\n.exam-btn-ghost:hover:not(:disabled) { background: var(--exam-surface-hover); color: var(--exam-text); }\n\n/* Ghost variant inside the dark sidebar */\n.exam-sidebar .exam-btn-ghost {\n  color: var(--exam-shell-text);\n}\n.exam-sidebar .exam-btn-ghost:hover:not(:disabled) {\n  background: var(--exam-shell-hover);\n  color: var(--exam-shell-text-active);\n}\n\n.exam-btn-danger {\n  background: var(--exam-error);\n  color: var(--exam-text-inverse);\n}\n\n/* ---- Badges ---------------------------------------------- */\n\n.exam-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 11px;\n  font-weight: 600;\n  padding: 2px 8px;\n  border-radius: var(--exam-radius-full);\n  letter-spacing: 0.02em;\n  white-space: nowrap;\n}\n\n.exam-badge-default  { background: var(--exam-surface-hover); color: var(--exam-text-secondary); }\n.exam-badge-primary  { background: var(--exam-primary-light); color: var(--exam-primary); }\n.exam-badge-success  { background: var(--exam-success-light); color: var(--exam-success); }\n.exam-badge-warning  { background: var(--exam-warning-light); color: var(--exam-warning); }\n.exam-badge-error    { background: var(--exam-error-light);   color: var(--exam-error); }\n.exam-badge-info     { background: var(--exam-info-light);    color: var(--exam-info); }\n\n/* ---- Form Elements --------------------------------------- */\n\n.exam-field {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n  margin-bottom: 16px;\n}\n\n.exam-label {\n  font-size: 12.5px;\n  font-weight: 500;\n  color: var(--exam-text-secondary);\n}\n\n.exam-label.required::after {\n  content: ' *';\n  color: var(--exam-error);\n}\n\n.exam-input,\n.exam-select,\n.exam-textarea {\n  font-family: var(--exam-font);\n  font-size: 13.5px;\n  color: var(--exam-text);\n  background: var(--exam-surface);\n  border: 1px solid var(--exam-border-strong);\n  border-radius: var(--exam-radius-sm);\n  padding: 8px 12px;\n  width: 100%;\n  transition: border-color var(--exam-transition), box-shadow var(--exam-transition);\n  outline: none;\n}\n\n.exam-input:focus,\n.exam-select:focus,\n.exam-textarea:focus {\n  border-color: var(--exam-primary);\n  box-shadow: 0 0 0 3px var(--exam-primary-light);\n}\n\n.exam-input::placeholder { color: var(--exam-text-muted); }\n\n.exam-textarea { resize: vertical; min-height: 80px; }\n\n/* ---- Step Progress --------------------------------------- */\n\n.exam-steps {\n  display: flex;\n  align-items: center;\n  margin-bottom: 32px;\n}\n\n.exam-step {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 6px;\n  position: relative;\n  flex: 1;\n}\n\n.exam-step:not(:last-child)::after {\n  content: '';\n  position: absolute;\n  top: 14px;\n  left: calc(50% + 14px);\n  right: calc(-50% + 14px);\n  height: 2px;\n  background: var(--exam-border);\n}\n\n.exam-step.completed::after { background: var(--exam-primary); }\n\n.exam-step-circle {\n  width: 28px;\n  height: 28px;\n  border-radius: var(--exam-radius-full);\n  border: 2px solid var(--exam-border-strong);\n  background: var(--exam-surface);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--exam-text-muted);\n  z-index: 1;\n  transition: all var(--exam-transition);\n}\n\n.exam-step.completed .exam-step-circle {\n  background: var(--exam-primary);\n  border-color: var(--exam-primary);\n  color: white;\n}\n\n.exam-step.current .exam-step-circle {\n  border-color: var(--exam-primary);\n  color: var(--exam-primary);\n  box-shadow: 0 0 0 4px var(--exam-primary-light);\n}\n\n.exam-step-label {\n  font-size: 11px;\n  font-weight: 500;\n  color: var(--exam-text-muted);\n  text-align: center;\n  white-space: nowrap;\n}\n\n.exam-step.current .exam-step-label,\n.exam-step.completed .exam-step-label {\n  color: var(--exam-text-secondary);\n}\n\n/* ---- Modal ----------------------------------------------- */\n\n.exam-modal-backdrop {\n  position: fixed;\n  inset: 0;\n  background: rgb(0 0 0 / 0.45);\n  z-index: var(--exam-z-modal);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 24px;\n}\n\n.exam-modal {\n  background: var(--exam-surface);\n  border-radius: var(--exam-radius-xl);\n  box-shadow: var(--exam-shadow-lg);\n  width: 100%;\n  max-width: 560px;\n  max-height: calc(100vh - 48px);\n  overflow-y: auto;\n  display: flex;\n  flex-direction: column;\n}\n\n.exam-modal-lg { max-width: 760px; }\n.exam-modal-xl { max-width: 960px; }\n\n.exam-modal-header {\n  padding: 20px 24px 0;\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.exam-modal-title {\n  font-size: 17px;\n  font-weight: 700;\n  color: var(--exam-text);\n  margin: 0;\n}\n\n.exam-modal-close {\n  width: 28px;\n  height: 28px;\n  border: none;\n  background: transparent;\n  border-radius: var(--exam-radius-sm);\n  cursor: pointer;\n  color: var(--exam-text-muted);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: background var(--exam-transition);\n  flex-shrink: 0;\n}\n\n.exam-modal-close:hover { background: var(--exam-surface-hover); color: var(--exam-text); }\n\n.exam-modal-body {\n  padding: 16px 24px;\n  flex: 1;\n}\n\n.exam-modal-footer {\n  padding: 0 24px 20px;\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n}\n\n/* ---- Table ----------------------------------------------- */\n\n.exam-table-wrap {\n  background: var(--exam-surface);\n  border: 1px solid var(--exam-border);\n  border-radius: var(--exam-radius-lg);\n  overflow: hidden;\n}\n\n.exam-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 13.5px;\n}\n\n.exam-table th {\n  text-align: left;\n  padding: 10px 16px;\n  font-size: 11.5px;\n  font-weight: 600;\n  color: var(--exam-text-muted);\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  border-bottom: 1px solid var(--exam-border);\n  background: var(--exam-bg);\n}\n\n.exam-table td {\n  padding: 12px 16px;\n  color: var(--exam-text);\n  border-bottom: 1px solid var(--exam-border);\n  vertical-align: middle;\n}\n\n.exam-table tbody tr:last-child td { border-bottom: none; }\n\n.exam-table tbody tr:hover td { background: var(--exam-surface-hover); }\n\n/* ---- Empty State ----------------------------------------- */\n\n.exam-empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  padding: 60px 24px;\n  gap: 12px;\n}\n\n.exam-empty-icon {\n  width: 56px;\n  height: 56px;\n  border-radius: var(--exam-radius-lg);\n  background: var(--exam-primary-light);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--exam-primary);\n  margin-bottom: 4px;\n}\n\n.exam-empty-title {\n  font-size: 16px;\n  font-weight: 600;\n  color: var(--exam-text);\n  margin: 0;\n}\n\n.exam-empty-body {\n  font-size: 13.5px;\n  color: var(--exam-text-muted);\n  margin: 0;\n  max-width: 320px;\n}\n\n/* ---- Utilities ------------------------------------------- */\n\n.exam-divider {\n  height: 1px;\n  background: var(--exam-border);\n  margin: 16px 0;\n}\n\n.exam-grid-2 { display: grid; grid-template-columns: 1fr 1fr; gap: 16px; }\n.exam-grid-3 { display: grid; grid-template-columns: repeat(3, 1fr); gap: 16px; }\n.exam-grid-4 { display: grid; grid-template-columns: repeat(4, 1fr); gap: 16px; }\n\n@media (max-width: 768px) {\n  .exam-grid-2,\n  .exam-grid-3,\n  .exam-grid-4 { grid-template-columns: 1fr; }\n\n  .exam-main { margin-left: 0; }\n  .exam-sidebar { transform: translateX(-100%); }\n  .exam-sidebar.mobile-open { transform: translateX(0); }\n}\n\n/* ---- Loading spinner ------------------------------------- */\n\n.exam-spinner {\n  width: 20px;\n  height: 20px;\n  border: 2px solid var(--exam-border);\n  border-top-color: var(--exam-primary);\n  border-radius: 50%;\n  animation: exam-spin 0.7s linear infinite;\n  display: inline-block;\n}\n\n@keyframes exam-spin {\n  to { transform: rotate(360deg); }\n}\n\n/* ---- Page headers ---------------------------------------- */\n\n.exam-page-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 24px;\n  gap: 16px;\n  flex-wrap: wrap;\n}\n\n.exam-page-title {\n  font-size: 20px;\n  font-weight: 700;\n  color: var(--exam-text);\n  margin: 0;\n  letter-spacing: -0.02em;\n}\n\n.exam-page-subtitle {\n  font-size: 13px;\n  color: var(--exam-text-muted);\n  margin: 2px 0 0;\n}\n\n/* ---- Search & Filter bar --------------------------------- */\n\n.exam-filter-bar {\n  display: flex;\n  gap: 10px;\n  align-items: center;\n  flex-wrap: wrap;\n  margin-bottom: 16px;\n}\n\n.exam-search-input {\n  flex: 1;\n  min-width: 200px;\n  max-width: 360px;\n  position: relative;\n}\n\n.exam-search-input input {\n  padding-left: 34px;\n}\n\n.exam-search-icon {\n  position: absolute;\n  left: 10px;\n  top: 50%;\n  transform: translateY(-50%);\n  color: var(--exam-text-muted);\n  pointer-events: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
